import { createSelector } from 'reselect'
import config from 'constants/config'

export const getChannelMarkup = createSelector(
  (state: App.State) => state.marketing.channelMarkup,
  (channelMarkup): App.ChannelMarkup | undefined => {
    return config.ENABLE_CHANNEL_MARKUP ? channelMarkup : undefined
  },
)
